export const PRIZE_CONSTANTS = {
  COUNTRY_CODE: 'CZ',
} as const;
